import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LoaderService, RestService } from '@stdoutsrl/design-kit';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styles: [],
  standalone: false
})
export class ProfileComponent implements OnInit {
  constructor(private loader: LoaderService, private rest: RestService) { }

  logged = false
  needLogin = false
  isRegistration = false
  isRecovery = false
  email = ""
  password = ""

  ngOnInit(): void {

    if (localStorage.getItem('token')) {
      this.getMe()
    } else {
      this.needLogin = true
    }
  }

  login() {
    this.loader.on()
    let params = {
      email: this.email,
      password: this.password
    }
    this.rest.post('/auth/login', params).subscribe({
      next: (value:any) => {
        this.loader.off(true)
        this.logged = true
        this.needLogin = false
        localStorage.setItem('token',value.accessToken)
        localStorage.setItem('user',JSON.stringify(value.user))
        this.rest.setToken(value.accessToken)
      },
      error: (value) => {
        this.loader.off(true)
      },
    })
  }

  getMe() {
    this.loader.on()
    this.rest.get(`/users/${JSON.parse(localStorage.getItem('user') ?? '').id}`).subscribe({
      next: (value) => {
        this.logged = true
        this.loader.off(true)
      },
      error: (value) => {
        this.loader.off(true)
        localStorage.clear()
        this.needLogin = true
      },
    })
  }
  
  logout(){
    localStorage.clear()
    window.location.reload()
  }
}
